import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import { NotReadyToBuyOnlineStyled } from '../NotReadyToBuyOnlineStyled';
export const NotReadyToBuyOnlineStyledOVGB = styled(NotReadyToBuyOnlineStyled)`
    background: ${({ theme }) => theme.colors.grey10};

    .title {
        font-size: ${rem('22px')};
    }

    .container {
        .wrapper {
            .innerTitle {
                .titleContent {
                }
                .icon {
                    .icon-wrapper,
                    svg {
                    }
                }
            }

            .innerContent {
                color: black;
                line-height: 1.25;

                .linkButton {
                    border: unset;
                    text-align: left;
                    padding: unset;
                    font-weight: bold;
                    text-transform: uppercase;
                    font-size: ${rem('14px')};
                    margin-top: ${rem('16px')};
                    color: black;
                    cursor: pointer;
                    position: relative;
                    width: fit-content;

                    .txt {
                        margin-right: ${rem('7px')};
                    }

                    .icon-wrapper {
                        svg path {
                            fill: black !important;
                            stroke: black !important;
                        }
                    }

                    &:hover {
                        .txt {
                            border-bottom: 1px solid black;
                        }
                    }
                }

                .innerContentTxt {
                    .contentItem {
                    }
                }
            }
        }
    }
`;
